<template>
  <div class="employee__input">
    <label>Name of label</label>
    <div>
      <input type="text" placeholder="First Name" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Input"
};
</script>

<style lang="scss" scoped>
.employee__input {
  max-width: 523px;

  > label {
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.22;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
  }

  > div {
    border: solid 1px #c7c7c7;
    background-color: #ffffff;

    > input {
      opacity: 0.32;
      font-size: 0.833vw;
      font-weight: 200;
      font-style: normal;
      font-stretch: normal;
      line-height: 2.5;
      letter-spacing: normal;
      text-align: left;
      color: #777777;
      outline: none;
      border: none;
      padding: 0 5px;
    }
  }
}
</style>
